import { get } from '../utils/httpInterceptor';
import { getCompanyId } from '../utils/companyHelper';

class MenuService {
  static async getCurrentUserMenu() {
    const companyId = getCompanyId();
    const query = companyId ? `?companyId=${companyId}` : '';
    return await get(`/me/menu${query}`);
  }
}

export default MenuService;

